<style lang="scss" scoped>
.activity-page-hero-row {
    margin-bottom: 96px !important;

    > .container {
        margin-bottom: -40px;
        padding-top: 10px;
    }

    .hero {
        background: var(--dark);
        position: absolute;
        top: -1px;
        left: 0;
        width: 100%;
        z-index: -1;
    }

    .divider {
        display: none;

        @media screen and (min-width: 768px) {
            display: inline-block;
            margin: 0 12px;
        }
    }

    .tag-row {
        margin-bottom: 28px;

        .tag-accent {
            transition: background-color 0.15s, border 0.15s, color 0.15s;
        }

        a:hover {
            text-decoration: none;

            .tag-accent {
                background-color: transparent;
                border: 1px solid #f39225;
                color: #f39225;
            }
        }
    }

    .location,
    .group-size,
    .duration {
        position: relative;
        padding-left: 48px;
        line-height: 24px;
        height: 24px;
        display: flex;

        span {
            display: inline-block;
            font-size: 1rem;
            line-height: 24px;
        }

        &:before {
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
        }
    }

    .location {
        &:before {
            content: url("/svg/icon-location.svg");
            width: 24px;
            height: 24px;
        }
    }

    .group-size {
        &:before {
            content: url("/svg/icon-group-size.svg");
            width: 22px;
            height: 22px;
        }
    }

    .duration {
        &:before {
            content: url("/svg/icon-clock.svg");
            width: 24px;
            height: 24px;
        }
    }

    @media screen and (min-width: 768px) {
        margin-bottom: 136px !important;

        > .container {
            margin-bottom: -80px;
        }
    }

    @media screen and (min-width: 1024px) {
        margin-bottom: 216px !important;

        > .container {
            margin-bottom: -160px;
        }
    }

    @media screen and (min-width: 1650px) {
        margin-bottom: 280px !important;

        > .container {
            margin-bottom: -200px;
        }
    }
}

.video-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 0.3s;

    &.loaded {
        opacity: 1;
    }

    ::v-deep iframe {
        width: calc(100% * 1.5);
        left: 50%;
        transform: translateX(-50%);
    }
}

/* images */

img {
    width: 100%;
    height: auto;
    object-fit: cover;
    font-family: "object-fit: cover;";
}

.template_1_images {
    img {
        height: 276px;

        @media screen and (min-width: 768px) {
            height: 480px;
        }

        @media screen and (min-width: 1280px) {
            height: 700px;
        }
    }
}

.template_2_images {
    .first,
    .second {
        width: 100%;
    }

    @media screen and (min-width: 768px) {
        .images {
            margin: 0 -12px;
            height: 380px;

            .first {
                width: 50%;
                padding: 0 12px;
            }

            .video-wrapper {
                padding: 0 12px;
            }

            .second {
                width: 50%;
                padding: 0 12px;
            }
        }
    }

    @media screen and (min-width: 1280px) {
        .images {
            height: 600px;

            .first {
                width: 30%;
            }

            .second {
                width: 70%;
            }
        }
    }
}

.template_3_images {
    @media screen and (min-width: 768px) {
        .second-third {
            margin: 0 -12px;

            div {
                width: 50%;
                padding: 0 12px;
            }
        }
    }

    @media screen and (min-width: 1024px) {
        .images {
            margin: 0 -12px;
            height: 500px;

            img,
            .video-wrapper {
                padding: 0 12px;
            }

            .first {
                width: 50%;
                height: 100%;
            }

            .second-third {
                width: 50%;
                height: 100%;
                margin: 0;

                div {
                    height: 50%;
                    width: 100%;
                    padding: 0;
                }
            }
        }
    }
}

.template_4_images {
    @media screen and (min-width: 768px) {
        .images {
            margin: 0 -12px;
            height: 500px;

            img,
            .video-wrapper {
                padding: 0 12px;
            }

            .first {
                width: 50%;
                height: 100%;
            }

            .right-col {
                width: 50%;
            }

            .second {
                width: 50%;
            }

            .third {
                width: 50%;
            }

            .fourth {
                width: 100%;
                height: 50%;
            }
        }
    }
}

.template_custom {
    .images {
        @media screen and (min-width: 1024px) {
            height: 380px;
        }

        .video-wrapper {
            padding: 0 12px;

            ::v-deep iframe {
                @media screen and (min-width: 1024px) {
                    width: calc(100% * 3.5);
                }
                @media screen and (min-width: 1280px) {
                    width: calc(100% * 3);
                }
            }
        }
    }
}
</style>

<template>
    <div class="d-flex position-relative pt-24 activity-page-hero-row" :class="type">
        <div class="hero h-100" ref="hero"></div>
        <div ref="contentContainer" class="container">
            <!-- 2 column header -->
            <div v-if="activity.acf.content.heading === 'left_aligned'" class="row mb-40 mb-lg-80 pt-md-40">
                <div class="col-12 col-lg-6">
                    <h2 class="text-white mb-16" v-html="activity.title.rendered"></h2>
                    <p v-if="activity.acf && activity.acf.content && activity.acf.content.introduction && activity.acf.content.introduction.bullet_points" class="text-white font-weight-light mb-40 mb-lg-0">
                        <span class="d-block intro-line" v-for="(intro, key) in activity.acf.content.introduction.bullet_points" :key="key">
                            {{ intro.bullet_point }}
                        </span>
                    </p>
                </div>
                <div class="col-12 col-lg-6">
                    <div v-if="relevantSubcategories" class="tag-row tag-row-lg mt-lg-16">
                        <div class="tag-col" v-for="category in relevantSubcategories" :key="category.id">
                            <a :href="route('nl.activities', {categories: category.slug})">
                                <div class="tag tag-accent tag-sm" v-html="category.name"></div>
                            </a>
                        </div>
                    </div>
                    <div v-if="location" class="location mt-40 mt-lg-16">
                        <span class="text-white font-weight-light" v-html="location.name"></span>
                    </div>
                    <div v-if="groupSize" class="group-size mt-16">
                        <span class="text-white font-weight-light" v-html="groupSize.name"></span>
                    </div>
                    <div v-if="duration" class="duration mt-16">
                        <span class="text-white font-weight-light" v-html="duration.name"></span>
                    </div>
                </div>
            </div>

            <!-- centered header -->
            <div v-if="activity.acf.content.heading === 'centered'" class="row mb-40 mb-md-80 pt-md-40">
                <div class="col-12 text-md-center align-items-md-center d-flex flex-column">
                    <div v-if="relevantSubcategories" class="tag-row tag-row-lg mb-24 order-2 order-md-0">
                        <div class="tag-col" v-for="category in relevantSubcategories" :key="category.id">
                            <a :href="route('nl.activities', {categories: category.slug})">
                                <div class="tag tag-accent tag-sm" v-html="category.name"></div>
                            </a>
                        </div>
                    </div>
                    <h2 class="text-white mb-16 order-0 order-md-1" v-html="activity.title.rendered"></h2>
                    <p v-if="activity.acf && activity.acf.content && activity.acf.content.introduction && activity.acf.content.introduction.bullet_points" class="order-1 order-md-2 text-white font-weight-light mb-40">
                        <span class="d-block d-md-inline" v-for="(intro, key) in activity.acf.content.introduction.bullet_points" :key="key">
                            {{ intro.bullet_point }} <span v-if="key < 2" class="divider">|</span>
                        </span>
                    </p>
                    <div class="d-flex flex-column flex-md-row order-4 order-md-3">
                        <div v-if="location" class="location mt-16 mr-md-40">
                            <span class="text-white font-weight-light" v-html="location.name"></span>
                        </div>
                        <div v-if="groupSize" class="group-size mt-16 mr-md-40">
                            <span class="text-white font-weight-light" v-html="groupSize.name"></span>
                        </div>
                        <div v-if="duration" class="duration mt-16">
                            <span class="text-white font-weight-light" v-html="duration.name"></span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- images template switch -->
            <template v-if="type === 'template_1_images'">
                <div class="position-relative">
                    <img class="w-100 h-100" :src="activity.acf.content.images[0].url" ref="primary" :alt="activity.title.rendered">
                    <template v-if="activity.acf.content.video_id != null && activity.acf.content.video_id != ''">
                        <div class="video-wrapper" :class="{'loaded': heroLoaded}">
                            <div ref="plyr" class="plyr__video-embed" id="player">
                                <iframe :src="`https://player.vimeo.com/video/${activity.acf.content.video_id}?loop=true&amp;autopause=false&amp;width=1024&amp;controls=false&amp;transparent=false&amp;gesture=media&amp;dnt=true`" allowfullscreen allowtransparency allow="autoplay"></iframe>
                            </div>
                        </div>
                    </template>
                </div>
            </template>

            <template v-else-if="type === 'template_2_images'">
                <div class="d-block d-md-flex flex-column flex-md-row images">
                    <img class="first mb-24 mb-md-0" :src="activity.acf.content.images[0].url" :alt="activity.title.rendered">
                    <div class="second position-relative">
                        <img class="w-100 h-100" ref="primary" :src="activity.acf.content.images[1].url" :alt="activity.title.rendered">
                        <template v-if="activity.acf.content.video_id != null && activity.acf.content.video_id != ''">
                            <div class="video-wrapper" :class="{'loaded': heroLoaded}">
                                <div ref="plyr" class="plyr__video-embed" id="player">
                                    <iframe :src="`https://player.vimeo.com/video/${activity.acf.content.video_id}?loop=true&amp;autopause=false&amp;width=1024&amp;controls=false&amp;transparent=false&amp;gesture=media&amp;dnt=true`" allowfullscreen allowtransparency allow="autoplay"></iframe>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </template>

            <template v-else-if="type === 'template_3_images'">
                <div class="d-block d-lg-flex flex-wrap images">
                    <div class="first position-relative mb-24 mb-lg-0">
                        <img class="w-100 h-100" ref="primary" :src="activity.acf.content.images[0].sizes.large" :alt="activity.title.rendered">
                        <template v-if="activity.acf.content.video_id != null && activity.acf.content.video_id != ''">
                            <div class="video-wrapper" :class="{'loaded': heroLoaded}">
                                <div ref="plyr" class="plyr__video-embed" id="player">
                                    <iframe :src="`https://player.vimeo.com/video/${activity.acf.content.video_id}?loop=true&amp;autopause=false&amp;width=1024&amp;controls=false&amp;transparent=false&amp;gesture=media&amp;dnt=true`" allowfullscreen allowtransparency allow="autoplay"></iframe>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="second-third d-flex flex-column flex-md-row flex-lg-column">
                        <div class="d-block d-lg-flex">
                            <img class="second mb-24 mb-md-0 mb-lg-24" :src="activity.acf.content.images[1].sizes.large" :alt="activity.title.rendered">
                        </div>
                        <div class="d-block d-lg-flex">
                            <img class="third" :src="activity.acf.content.images[2].sizes.large" :alt="activity.title.rendered">
                        </div>
                    </div>
                </div>
            </template>

            <template v-else-if="type === 'template_4_images'">
                <div class="d-block d-md-flex flex-wrap images">
                    <div class="first position-relative mb-24 mb-md-0">
                        <img class="w-100 h-100" ref="primary" :src="activity.acf.content.images[0].sizes.large" :alt="activity.title.rendered">
                        <template v-if="activity.acf.content.video_id != null && activity.acf.content.video_id != ''">
                            <div class="video-wrapper" :class="{'loaded': heroLoaded}">
                                <div ref="plyr" class="plyr__video-embed" id="player">
                                    <iframe :src="`https://player.vimeo.com/video/${activity.acf.content.video_id}?loop=true&amp;autopause=false&amp;width=1024&amp;controls=false&amp;transparent=false&amp;gesture=media&amp;dnt=true`" allowfullscreen allowtransparency allow="autoplay"></iframe>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="d-block d-md-flex flex-column right-col h-100">
                        <div class="d-block d-md-flex flex-column flex-md-row w-100 h-50 pb-24">
                            <img class="second mb-24 mb-md-0" :src="activity.acf.content.images[1].sizes.large" :alt="activity.title.rendered">
                            <img class="third" :src="activity.acf.content.images[2].sizes.large" :alt="activity.title.rendered">
                        </div>
                        <img class="fourth" :src="activity.acf.content.images[3].sizes.large" :alt="activity.title.rendered">
                    </div>
                </div>
            </template>

            <template v-if="type === 'template_custom'">
                <div class="row images">
                    <div class="col-12 col-lg-3 mb-16 mb-lg-0 h-100" v-for="(image, index) in activity.acf.content.images.slice(0,4)" :key="image.id">
                        <img class="w-100 h-100" ref="customimage" :src="image.url" :alt="activity.title.rendered">
                        <template v-if="index == 0 && activity.acf.content.video_id != null && activity.acf.content.video_id != ''">
                            <div class="video-wrapper" :class="{'loaded': heroLoaded}">
                                <div ref="plyr" class="plyr__video-embed" id="player">
                                    <iframe :src="`https://player.vimeo.com/video/${activity.acf.content.video_id}?loop=true&amp;autopause=false&amp;width=1024&amp;controls=false&amp;transparent=false&amp;gesture=media&amp;dnt=true`" allowfullscreen allowtransparency allow="autoplay"></iframe>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import Plyr from 'plyr';

export default {
    name: "pageParts.activity-page-hero",

    props: {
        activity: {
            type: Object,
            required: true
        }
    },

    data: (vm) => ({
        type: vm.activity.acf.template,
        loaded: false,
        videoPlayer: null
    }),

    mounted() {
        if (this.activity.acf.content.video_id != null && this.activity.acf.content.video_id != '' && !this.isInternetExplorer()) {
            var self = this;
            setTimeout(function () {
                self.loaded = true;
                self.videoPlayer = new Plyr("#player", {
                    muted: true,
                    hideControls: false,
                    disableContextMenu: false,
                    autoplay: true,
                    ratio: (self.type == "template_custom" ? `${self.$refs.customimage[0].clientWidth - 24}:${self.$refs.customimage[0].clientHeight}` : `${self.$refs.primary.clientWidth - 24}:${self.$refs.primary.clientHeight}`),
                    controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'airplay', 'fullscreen']
                });
            }, 2000);
        }
    },

    methods: {
        isInternetExplorer() {
            var ua = window.navigator.userAgent;
            var msie = ua.indexOf("MSIE ");

            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
            {
                return true;
            }
            else  // If another browser, return 0
            {
                return false;
            }
        }
    },

    computed: {
        relevantSubcategories() {
            var excludedParentCategories = [0, 2, 4, 24, 25]
            return this.activity.categories.filter(a => (!excludedParentCategories.includes(a.parent)));
        },

        duration() {
            return this.activity.categories.find(a => a.parent == 2);
        },

        groupSize() {
            let groupSizeChoice = this.activity.categories.find(c => c.term_id === 48)
            if (groupSizeChoice) {
                return groupSizeChoice
            }
            return this.activity.categories.slice().reverse().find(a => a.parent == 4);
        },

        location() {
            let locationChoice = this.activity.categories.find(c => c.term_id === 42)
            if (locationChoice) {
                return locationChoice
            }
            return this.activity.categories.find(c => c.parent === 25 || c.parent === 24)
        },

        heroLoaded() {
            return this.loaded;
        },
    },
}
</script>